import {
  IconAsterisk,
  IconCustomAsteriskOff,
  IconCustomExportOff,
  IconEye,
  IconEyeOff,
  IconLogout,
  TablerIcon,
} from '@rossum/ui/icons/tabler';
import { SvgIcon } from '@rossum/ui/material';
import { FieldsFormModel } from '../../form-model/formModels';

export type QuickActionField = keyof Pick<
  FieldsFormModel['field'],
  'exported' | 'hidden' | 'required'
>;

const quickIcons = {
  hidden: {
    on: IconEye,
    off: IconEyeOff,
  },
  exported: {
    on: IconLogout,
    off: IconCustomExportOff,
  },
  required: {
    on: IconAsterisk,
    off: IconCustomAsteriskOff,
  },
};

export const getQuickActionIcon = (
  fieldKey: QuickActionField,
  state: boolean
): TablerIcon => {
  return quickIcons[fieldKey][state ? 'on' : 'off'];
};

type QuickActionIconProps = {
  fieldKey: QuickActionField;
  state: boolean;
  disabled?: boolean;
};

export const QuickActionIcon = ({
  fieldKey,
  state,
  disabled,
}: QuickActionIconProps) => {
  const Icon = getQuickActionIcon(fieldKey, state);

  return (
    <SvgIcon
      fontSize="medium"
      color={disabled ? 'disabled' : state ? 'success' : 'action'}
    >
      <Icon />
    </SvgIcon>
  );
};
